import { cn } from '@/utils/cn';

type RibbonBannerProps = {
  phase: 'PROD' | 'BETA' | 'ALPHA';
};

const RibbonBanner = ({ phase }: RibbonBannerProps) => {
  const displayCn = phase !== 'PROD' ? 'display' : 'hidden';
  const backgroundCn = phase === 'BETA' ? 'bg-sky-700' : 'bg-emerald-700';

  return (
    <div className={cn(displayCn, 'size-20', 'overflow-hidden')}>
      <div
        className={cn(
          backgroundCn,
          ['text-center', 'text-white', 'font-bold'],
          ['top-1', '-right-8'],
          'absolute',
          'w-28',
          'py-2',
          'rotate-45',
          'drop-shadow-lg',
        )}
      >
        {phase}
      </div>
    </div>
  );
};

RibbonBanner.displayName = 'RibbonBanner';

export { RibbonBanner };
